import styled from "styled-components";

let S = {};

S.BackContainer = styled.div`
	width: 100%;
	text-align: left;

	& > button {
		display: inline-block;
		border: none;
		border: 1px solid var(--primary);
		border-radius: 4px;
		padding: 5.5px 12.5px 5px 7.5px;
		margin: 0;
		text-decoration: none;
		background: transparent;
		background-color: #fff;
		font-family: inherit;
		font-size: 0.9rem;
		cursor: pointer;
		appearance: none;
		-moz-appearance: none;
		outline: none;
		transition: all 0.3s;

		&:hover {
			background-color: var(--primary);
			color: #fff;
		}

		& > div {
			width: 100%;
			display: flex;
			align-items: center;

			& > span {
				white-space: nowrap;
				padding-top: 1px;
				padding-left: 7.5px;
			}
		}
	}
`;

S.Item = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 7.5px;

	@media only screen and (max-width: 767px) {
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
	}

	& > div {
		display: flex;
		align-items: center;

		@media only screen and (max-width: 767px) {
			flex-direction: column;
		}

		& > img {
			display: block;
			width: 100%;
			height: auto;
			width: 150px;
			border-radius: 10px;
			border: 1px solid var(--lightblue);

			@media only screen and (max-width: 767px) {
				display: none;
			}
		}

		& > div {
			margin-left: 15px;

			& > ul {
				margin: 0;
				padding: 0;
				margin-left: 30px;
				font-size: 0.9rem;

				& > li {
					margin: 0;
					padding: 0;
					line-height: 22px;
				}
			}

			& > small {
				font-style: italic;
				font-size: 0.8rem;
			}
		}
	}

	& > button {
		border: none;
		border-radius: 0;
		padding: 0;
		margin: 0;
		text-decoration: none;
		background: transparent;
		font-family: inherit;
		font-size: 1rem;
		cursor: pointer;
		appearance: none;
		-moz-appearance: none;
		outline: none;
		color: var(--error);

		@media only screen and (max-width: 767px) {
			margin-top: 15px;
		}
	}
`;

S.ReCAPTCHACheckbox = styled.div`
	width: 100%;
	padding-top: 15px;
	display: flex;
	flex-direction: column;

	&.hidden {
		display: none;
	}

	& > *:last-child {
		padding-top: 10px;
	}
`;

S.LoadingContainer = styled.div`
	margin-top: 25px;
`;

export default S;
